import React from "react";
import PropTypes from "prop-types";
import { SearchForm } from "@vitalsource/vstui";

class SearchField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value || ""
    };
  }

  componentDidMount() {
    window.addEventListener("update-search-term", this.updateTerm);
  }

  componentWillUnmount() {
    window.removeEventListener("update-search-term", this.updateTerm);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.value) {
      this.setState({ value: nextProps.value });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.value !== this.state.value) {
      if (this.props.onChange) {
        this.props.onChange(this.state.value);
      }
    }
  }

  updateTerm = e => {
    this.setState({ value: e.value });
  };

  onChange = e => {
    const value = e.currentTarget.value;
    this.setState({
      value
    });
  };

  onSubmit = e => {
    e.preventDefault();
    if (this.props.search) {
      this.props.search(this.state.value);
      Fraction.Helpers.logNPSFeedbackEvent("searches");
    }
  };

  onClearRequest = () => {
    if (this.props.reset) {
      this.props.reset();
    }
    this.setState({
      value: ""
    });
  };

  render() {
    return (
      <div className="search-input">
        <SearchForm
          placeholder={this.props.placeholder}
          fullWidth
          value={this.state.value}
          onChange={this.onChange}
          formProps={{
            onSubmit: this.onSubmit
          }}
          incremental={this.props.incremental}
          onClearRequest={this.onClearRequest}
        />
      </div>
    );
  }
}

SearchField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  search: PropTypes.func,
  incremental: PropTypes.bool,
  reset: PropTypes.func
};

module.exports = SearchField;
